<template>
  <!--更多设置-->
  <div class="console-setting-wrap">
    <el-tabs v-model="activeName" @tab-click="tableClick">
      <!-- 审批管理 ssssssssss -->
      <el-tab-pane name="tab-member" v-if="showMember">
        <span slot="label">成员管理</span>
        <member />
      </el-tab-pane>

      <!-- 审批管理 ssssssssss -->

      <!-- 审批管理 ssssssssss -->
      <el-tab-pane name="tab-approval" v-if="showApproval">
        <span slot="label">审批设置</span>
        <flow />
      </el-tab-pane>

      <!-- 审批管理 ssssssssss -->

      <!-- 印章管理 ssssssssss -->
      <el-tab-pane name="tab-seal" v-if="showSeal">
        <span slot="label">印章授权</span>
        <seal />
      </el-tab-pane>
      <!-- 印章管理 eeeeeeeeee -->

      <!-- 模板管理 ssssssssss -->
      <el-tab-pane name="tab-template" v-if="showTemplate">
        <span slot="label">模板授权</span>
        <template-manage />
      </el-tab-pane>

      <!-- 模板管理 ssssssssss -->
    </el-tabs>
  </div>
</template>

<script>
import seal from "./seal"; // 印章管理
import flow from "./flow"; // 审批管理
import templateManage from "./template"; // 模板管理
import member from "./member"; //成员管理
export default {
  components: { seal, flow, templateManage, member },
  data() {
    return {
      activeName: "tab-member",
      showSeal: false,
      showApproval: false,
      showTemplate: false,
      showMember: false
    };
  },
  name: "console-setting-wrap",
  created() {
    this.setActiveName(this.$store.getters.consoleToken);
  },
  watch: {
    "$store.getters.consoleToken": {
      handler(newVal) {
        this.setActiveName(newVal);
      },
      deep: true
    },
    $route: function(newVal) {
      this.setActiveName(this.$store.getters.consoleToken);
    }
  },
  methods: {
    setActiveName(consoleToken = this.$store.getters.consoleToken) {
      let showSeal = consoleToken.perms.some(i => +i == 4);
      let showApproval = consoleToken.perms.some(i => +i == 12);
      let showTemplate = consoleToken.perms.some(i => +i == 6);
      let showMember = consoleToken.perms.some(i => +i == 3);

      var activeName = "";
      if (this.$route.query.activeName) {
        activeName = this.$route.query.activeName;
      } else {
        // 初始选中
        if (showTemplate) {
          activeName = "tab-template";
        }
        if (showSeal) {
          activeName = "tab-seal";
        }

        if (showApproval) {
          activeName = "tab-approval";
        }
        if (showMember) {
          activeName = "tab-member";
        }
      }

      setTimeout(() => {
        this.activeName = activeName;
        this.showSeal = showSeal;
        this.showApproval = showApproval;
        this.showTemplate = showTemplate;
        this.showMember = showMember;
      });
    },
    tableClick(val) {
      val &&
        this.$router.push({
          path: "/console/setting",
          query: { activeName: val.name }
        });
    }
  }
};
</script>

<style lang="less" scoped>
.console-setting-wrap {
  padding: 0;
  border-radius: 2px;

  /deep/ .el-tabs__active-bar {
    background-color: #f10e0e;
  }

  /deep/ .el-tabs__header {
    /*padding-top: 10px;*/
    margin: 0;
    background: #ffffff;
  }

  /deep/ .el-tabs__content {
    padding: 0;
  }

  /deep/ .el-tabs__item {
    color: rgba(41, 2, 2, 1);

    &.is-active {
      color: #f10e0e;
      font-weight: bold;
    }

    span {
      padding: 0 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/console/setting.vue